export enum CardSortField {
   JOB_TITLE = "job_title",
   NAME = "name",
}

export const benchSortFieldMaps: { [key: string]: string } = {
   job_title: "position",
   name: "name",
};
